// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".metRequirements[data-v-30fef208]{color:green}.gray-header[data-v-30fef208]{background-color:#aaa !important;margin-top:5px;padding:2px 8px;font-size:1.2em}.instructions h1[data-v-30fef208]{background-color:none !important;color:#000 !important}.instructions[data-v-30fef208]{padding:20px 30px !important;border-radius:5px !important;background-color:#d6eef7 !important;color:#157291 !important;margin-top:20px !important}", ""]);
// Exports
module.exports = exports;
